(function ($, w, undefined) {

    let PhonesEvents = {
        init: function () {
            this.objects = $('.j-phone-item');
            this.isMobile = GLOBAL.isMobile;
            let self = this;

            this.objects.each(function () {
                self.initPhone(this);
            });
        },

        initPhone: function (selector) {

            let me = $(selector);

            if (!this.isMobile) {
                me.off('mouseenter.phones').on('mouseenter.phones', function () {
                    triggerMarketingEvent('hover_phones', []);
                });
            }

            if (this.isMobile) {
                me.off('click.phones').on('click.phones', function () {
                    triggerMarketingEvent('call_phones', []);
                });
            }
        },
    };

    $.extend(PhonesEvents, TMEvents);

    $(function () {
        PhonesEvents.init();
    });

    w.PhonesEvents = PhonesEvents;

})(jQuery, window);
